"use client"

import { useEffect } from "react";
import '~/styles/globals.css';
import { tstl } from "~/utils/json-template-strings";
import { errorJson } from "~/consts/error";
import { log, errorToLogObj } from "~/lib/logger";

export default function LandingError({ error }: { error: Error & { digest?: string } }) {

    useEffect(() => {
        log.event("react_render_crash", errorToLogObj(error));
    }, [error]);

    return (
        <html>
            <body>
                <main className="flex min-h-screen flex-col items-center p-24">
                    <p>Global error</p>
                    <h1>{tstl(errorJson.billManagement)}</h1>
                    <p>{tstl(errorJson.errorLoading)}</p>
                </main>
            </body>
        </html>
    )
}
